import * as React from 'react';
import { setCookie } from '@cian/utils/lib/browser/cookie';

import { deleteCookie, getCookie } from '../../utils/cookie';

import { IRegion } from './types';

import {
  FOREVER_REGION_NAME_COOKIE_KEY,
  FOREVER_REGION_ID_COOKIE_KEY,
  FOREVER_MAIN_TOWN_REGION_ID_COOKIE_KEY,
  SESSION_REGION_ID_COOKIE_KEY,
  SESSION_MAIN_TOWN_REGION_ID_COOKIE_KEY,
  SESSION_REGION_NAME_COOKIE_KEY,
} from './constants';

import { getPopularCitiesForGeopopup } from './utils/get_popular_cities_for_geopopup';
import { getRegion } from './utils/get_region';

import { GeoSwitcherView } from './geo_switcher_view';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface IGeoSwitcherProps {
  newHeaderEnabled: boolean;
  geoSwitcherPopup: boolean;
}

interface IGeoSwitcherState {
  currentLocation?: IRegion | void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  popularCities?: any[];
}

export class GeoSwitcher extends React.Component<IGeoSwitcherProps, IGeoSwitcherState> {
  private withTooltip: boolean;

  public constructor(props: IGeoSwitcherProps) {
    super(props);

    this.state = {};

    this.withTooltip = props.geoSwitcherPopup && !getCookie(FOREVER_REGION_ID_COOKIE_KEY);
  }

  public componentDidMount() {
    this.ensureCurrentRegion();
    this.ensurePopularCities();
  }

  public render() {
    const { currentLocation } = this.state;

    if (!currentLocation) {
      return null;
    }

    return (
      <GeoSwitcherView
        newHeaderEnabled={this.props.newHeaderEnabled}
        currentLocation={currentLocation}
        popularCities={this.state.popularCities}
        onAcceptLocation={this.handleAcceptLocation}
        withTooltip={this.withTooltip}
      />
    );
  }

  private handleAcceptLocation = (region: IRegion) => {
    this.setSelectedRegionCookie(region);
  };

  private async setSelectedRegionCookie(selectedRegion: IRegion) {
    this.setCookies(selectedRegion);

    let { baseHost } = selectedRegion;

    // Если baseHost придет - нам не нужно слать лишний запрос
    if (!baseHost) {
      // Math.abs тут до тех пор, пока API не сможет отвечать на отрицательные ID
      const response = await getRegion(Math.abs(selectedRegion.id));

      if (response.statusCode === 200) {
        baseHost = response.response.data.baseHost as string;
      }
    }

    const { currentLocation } = this.state;

    if (baseHost && currentLocation && currentLocation.baseHost !== selectedRegion.baseHost) {
      location.href = this.buildRedirectUrl(baseHost);
    }
  }

  private setCookies = (selectedRegion: IRegion) => {
    const { mainTownId, displayName } = selectedRegion;
    // Math.abs тут до тех пор, пока саджесты не научатся в отрицательные id
    const id = Math.abs(selectedRegion.id);
    const currentDate = new Date();
    const dateThroughOneYear = new Date(currentDate.setFullYear(currentDate.getFullYear() + 1));

    setCookie(SESSION_REGION_ID_COOKIE_KEY, `${id}`, {
      secure: false,
    });
    setCookie(SESSION_REGION_NAME_COOKIE_KEY, `${displayName}`, {
      secure: false,
    });

    setCookie(FOREVER_REGION_ID_COOKIE_KEY, `${id}`, {
      expires: dateThroughOneYear,
      secure: false,
    });
    setCookie(FOREVER_REGION_NAME_COOKIE_KEY, `${displayName}`, {
      expires: dateThroughOneYear,
      secure: false,
    });

    if (mainTownId) {
      setCookie(SESSION_MAIN_TOWN_REGION_ID_COOKIE_KEY, `${mainTownId}`, {
        secure: false,
      });
      setCookie(FOREVER_MAIN_TOWN_REGION_ID_COOKIE_KEY, `${mainTownId}`, {
        expires: dateThroughOneYear,
        secure: false,
      });
    } else {
      deleteCookie(SESSION_MAIN_TOWN_REGION_ID_COOKIE_KEY);
      deleteCookie(FOREVER_MAIN_TOWN_REGION_ID_COOKIE_KEY);
    }
  };

  private buildRedirectUrl = (baseHost: string): string => {
    let innerBaseHost = baseHost;

    if (location.port.length) {
      innerBaseHost += ':' + location.port;
    }

    return innerBaseHost + location.pathname + location.search;
  };

  private async ensureCurrentRegion() {
    // Math.abs тут до тех пор, пока API не сможет отвечать на отрицательные ID
    const regionId =
      Math.abs(
        parseInt(getCookie(SESSION_REGION_ID_COOKIE_KEY), 10) || parseInt(getCookie(FOREVER_REGION_ID_COOKIE_KEY), 10),
      ) || 1;

    const response = await getRegion(regionId);

    let region: IRegion | void;

    if (response.statusCode === 200) {
      region = response.response.data as IRegion;
    }

    this.setState({
      currentLocation: region,
    });
  }

  private async ensurePopularCities() {
    const popularCities = await getPopularCitiesForGeopopup();

    this.setState({ popularCities });
  }
}
